import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { primaryShadow } from '@design-system/theme';
import { AddOptionalLink } from './components/AddOptionalLink';
import { AddOptionalTooltip } from './components/AddOptionalTooltip';
import { Picture } from './components/Picture';
const Wrapper = styled(Box) `
  user-select: none;

  img {
    background-color: ${({ $withBackground, theme }) => $withBackground
    ? theme.themeVariables.frameBackgroundColor
    : 'transparent'};
    border-radius: ${({ $isSquare, theme }) => $isSquare ? `${theme.themeVariables.globalBorderRadius}px` : '50%'};
    border: solid
      ${({ $borderWidth, $withBorder, theme }) => $withBorder
    ? `${$borderWidth}px ${theme.themeVariables.frameBackgroundColor}`
    : '0px'};
    ${({ $withShadow }) => ($withShadow ? primaryShadow : 'box-shadow: none')};
    width: inherit;
  }
`;
export const Avatar = (_a) => {
    var { alt, borderWidth = 2, dataTestId, fallback, href, isExternalLink = false, isSquare = false, onError, onLoad, position = 'relative', size = '100%', src, state, tooltip, withBackground = false, withBorder = false, withShadow = false } = _a, props = __rest(_a, ["alt", "borderWidth", "dataTestId", "fallback", "href", "isExternalLink", "isSquare", "onError", "onLoad", "position", "size", "src", "state", "tooltip", "withBackground", "withBorder", "withShadow"]);
    return (_jsx(AddOptionalLink, { href: href, isExternalLink: isExternalLink, children: _jsx(AddOptionalTooltip, { tooltip: tooltip, children: _jsx(Wrapper, Object.assign({ "$borderWidth": borderWidth, "$isSquare": isSquare, "$withBackground": withBackground, "$withBorder": withBorder, "$withShadow": withShadow, height: size, position: position, width: size }, props, { children: _jsx(Picture, { alt: alt, dataTestId: dataTestId, fallback: fallback, onError: onError, onLoad: onLoad, src: src, state: state }) })) }) }));
};
//# sourceMappingURL=Avatar.js.map